import { ROOT_URL, GET_USER_API } from '../main/constants/endpoints';
import axios, { AxiosResponse } from 'axios';
import { IUserPayload, User } from '../models/User';
import { OnboardingNotifications } from '../models/OnboardingNotifications';
import applyConverters from 'axios-case-converter';

export const fetchUser = async (): Promise<{ user: User; onboarding: OnboardingNotifications }> => {
    const client = applyConverters(axios.create());
    const response: AxiosResponse<IUserPayload> = await client.get(`${ROOT_URL}/${GET_USER_API}`, {
        withCredentials: true,
        headers: { Pragma: 'no-cache' },
    });

    const isRedirectStatus = response.status === 302;

    if (isRedirectStatus) {
        throw new Error();
    }

    return {
        user: new User(response.data),
        onboarding: new OnboardingNotifications(response.data.onBoarding),
    };
};
